/* oxlint-disable cf-web/no-barrel-file */
import invariant from 'tiny-invariant'

// eslint-disable-next-line no-barrel-files/no-barrel-files
export { invariant }
